import axios from "axios";

import {
  errorInterceptor,
  unauthorizedInterceptor,
  sessionInterceptor,
} from "axios/interceptors";

const axiosConfig = () => {
  axios.defaults.baseURL = `${process.env.REACT_APP_API_HOST}/v1`;
  axios.interceptors.request.use(sessionInterceptor, errorInterceptor);
  axios.interceptors.response.use(undefined, errorInterceptor);
  axios.interceptors.response.use(undefined, unauthorizedInterceptor);
};

export default axiosConfig;
